export default "__VITE_ASSET__7IhLAlY8__"